import { useVConsole } from '@hooks/index.ts';

import { AppProviders } from './context/index.tsx';
import HomePage from './pages/HomePage.tsx';

import './i18n/config';

function App() {
  useVConsole();

  return (
    <AppProviders>
      <HomePage />
    </AppProviders>
  );
}

export default App;
